import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Modules
import { AccountsRoutingModule } from './accounts-routing.module';
import { SharedModule } from "../../shared/components/shared.module";
// import { FeedsModule } from 'src/app/shared/components/feeds/feeds.module';
// Components
import { CreateAccountComponent } from './list/create-account/create-account.component';
import { AccountListHomeComponent } from './list/account-list-home/account-list-home.component';
import { AccountHomeComponent } from './home/account-home/account-home.component';
import { AccountScoreHomeComponent } from './scores/account-score-home/account-score-home.component';
import { AccountInboxHomeComponent } from './inbox/account-inbox-home/account-inbox-home.component';
import { AccountEngagementHomeComponent } from './engagement/account-engagement-home/account-engagement-home.component';
import { AccountSettingsHomeComponent } from './settings/account-settings-home/account-settings-home.component';
import { DefaultRoutingComponent } from './default-routing/default-routing.component';
import { BarViewComponent } from 'src/app/shared/components/bar-view/bar-view.component';
import { ChartViewComponent } from 'src/app/shared/components/chart-view/chart-view.component';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { GroupBarViewComponent } from 'src/app/shared/components/group-bar-view/group-bar-view.component';
import { AccountSettingsProjectComponent } from './settings/account-settings-project/account-settings-project.component';
import { AccountSettingsUserAccessComponent } from './settings/account-settings-user-access/account-settings-user-access.component';
import { AccountSettingsDashboardConfigureComponent } from './settings/account-settings-dashboard-configure/account-settings-dashboard-configure.component';
import { AccountSettingsSecurityComponent } from './settings/account-settings-security/account-settings-security.component';
import { AccountSettingsNotificationComponent } from './settings/account-settings-notification/account-settings-notification.component';
// Moved this components from account specific module to shared module
// import { LtmsCustomDropdownComponent } from 'src/app/shared/components/ltms-custom-dropdown/ltms-custom-dropdown.component';
// import { LtmsLineChartViewComponent } from 'src/app/shared/components/graph/ltms-line-chart-view/ltms-line-chart-view.component'
// import { LtmsBarChartViewComponent } from 'src/app/shared/components/graph/ltms-bar-chart-view/ltms-bar-chart-view.component'
import { FormsModule } from '@angular/forms';
import { LtmsDataTableV2Component } from 'src/app/shared/components/ltms-data-table-v2/ltms-data-table-v2.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        // FeedsModule,
        AccountsRoutingModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        // BrowserAnimationsModule, // Keep animations module only in root AppModule
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgbModule,
        CreateAccountComponent,
        AccountListHomeComponent,
        AccountHomeComponent,
        AccountScoreHomeComponent,
        AccountInboxHomeComponent,
        AccountEngagementHomeComponent,
        AccountSettingsHomeComponent,
        DefaultRoutingComponent,
        BarViewComponent,
        ChartViewComponent,
        LoaderComponent,
        GroupBarViewComponent,
        AccountSettingsProjectComponent,
        AccountSettingsUserAccessComponent,
        AccountSettingsDashboardConfigureComponent,
        AccountSettingsSecurityComponent,
        AccountSettingsNotificationComponent
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AccountsModule { }
